import React from 'react';
import { Search } from 'lucide-react';

const FilterBar = ({ categories, filter, onFilterChange, search, onSearchChange, stats, mode = 'admin', onInstallAll, onRemoveAll, onUpdateAll, hasUpdates }) => {
  // Safe access to stats with fallbacks
  const total = stats?.total || 0;
  const installed = stats?.installed || 0;
  const available = stats?.available || 0;
  const filtered = stats?.filtered || 0;

  // Determine if we're in public mode
  const isPublic = mode === 'public';

  // Safe access to categories
  const categoryList = categories || [];

  return (
	<div className="or-mb-6">
	  {/* Header Stats */}
	  <div className="or-flex or-justify-between or-items-center or-mb-4 or-flex-wrap or-gap-4">
		<div className="or-flex or-items-center or-gap-3">
		  <div className="or-px-4 or-py-2 or-bg-white or-rounded-lg or-border or-border-gray-200 or-shadow-sm">
			<span className="or-text-2xl or-font-bold or-text-gray-900">{total}</span>
			<span className="or-text-sm or-text-gray-600 or-ml-1">{isPublic ? 'Blocks' : 'Total'}</span>
		  </div>
		  {!isPublic && (
			<div className="or-px-4 or-py-2 or-bg-green-50 or-rounded-lg or-border or-border-green-200">
			  <span className="or-text-2xl or-font-bold or-text-green-700">{installed}</span>
			  <span className="or-text-sm or-text-green-600 or-ml-1">Installed</span>
			</div>
		  )}
		  {!isPublic && (
			<div className="or-px-4 or-py-2 or-bg-primary-100 or-rounded-lg or-border or-border-primary-200">
			  <span className="or-text-2xl or-font-bold or-text-primary-700">{available}</span>
			  <span className="or-text-sm or-text-primary-600 or-ml-1">Available</span>
			</div>
		  )}
		</div>
		<div className="or-flex or-items-center or-gap-2">
		  <span className="or-text-sm or-text-gray-500 or-mr-2">Showing {filtered} blocks</span>
		  {!isPublic && hasUpdates && (
			<button onClick={onUpdateAll} className="button button-secondary or-text-sm or-flex or-items-center or-gap-2">
			  <i className="fa-solid fa-arrows-rotate or-mr-2" style={{color: '#7504CD'}}></i>
			  Update All
			</button>
		  )}
		  {!isPublic && available > 0 && (
			<button onClick={onInstallAll} className="button button-secondary or-text-sm or-flex or-items-center or-gap-2">
			  <i className="fa-solid fa-download or-mr-2" style={{color: '#7504CD'}}></i>
			  Install All
			</button>
		  )}
		  {!isPublic && installed > 0 && (
			<button onClick={onRemoveAll} className="button button-secondary or-text-sm or-flex or-items-center or-gap-2">
			  <i className="fa-solid fa-trash-can or-mr-2" style={{color: '#7504CD'}}></i>
			  Remove All
			</button>
		  )}
		</div>
	  </div>

	  {/* Categories and Search */}
	  <div className="or-bg-white or-p-4 or-rounded-lg or-border or-space-y-4">
		{/* Categories Pills */}
		<div className="or-flex or-flex-wrap or-gap-2">
		  <button
			onClick={() => onFilterChange && onFilterChange('all')}
			className={`or-px-6 or-py-3 or-rounded-full or-text-xs or-font-medium or-transition-all or-duration-200 or-border ${
			  filter === 'all'
				? 'or-bg-primary-700 or-text-white or-border-primary-700'
				: 'or-bg-white or-text-gray-700 or-border-gray-300 hover:or-bg-gray-50'
			}`}
		  >
			All Categories
		  </button>
		  
		  {categoryList.map((category, index) => {
			const categoryKey = typeof category === 'string' ? category : category.slug || category.name || index;
			const categoryValue = typeof category === 'string' ? category : category.slug || category.name || 'Unknown';
			const rawLabel = typeof category === 'string' ? category : category.name || category.slug || 'Unknown';
			// Capitalize first letter of each word
			const categoryLabel = rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1);

			return (
			  <button
				key={categoryKey}
				onClick={() => onFilterChange && onFilterChange(categoryValue)}
				className={`or-px-6 or-py-3 or-rounded-full or-text-xs or-font-medium or-transition-all or-duration-200 or-border ${
				  filter === categoryValue
					? 'or-bg-primary-700 or-text-white or-border-primary-700'
					: 'or-bg-white or-text-gray-700 or-border-gray-300 hover:or-bg-gray-50'
				}`}
			  >
				{categoryLabel}
			  </button>
			);
		  })}
		</div>

		{/* Search - Full Width */}
		<div className="or-searchbar or-relative">
		  <Search className="or-absolute or-left-2 or-top-1/2 or-transform or--translate-y-1/2 or-text-gray-300 or-pointer-events-none" size={20} />
		  <input
			type="text"
			placeholder="Search blocks..."
			value={search || ''}
			onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
			className="or-w-full or-pl-12 or-pr-4 or-py-3 or-border or-border-gray-300 or-rounded-lg focus:or-ring-2 focus:or-ring-primary-500 focus:or-border-primary-500 or-outline-none or-text-sm"
		  />
		</div>
	  </div>
	</div>
  );
};

export default FilterBar;